import React from 'react';
import ModalX from '../../components/modal-x';

const PrivacyPolicyModal = ({ isOpen, onClose }) => {
    return (
        <ModalX
            isOpen={isOpen}
            onClose={onClose}
            maxWidth="xxxl"
            title="Privacy Policy"
        >
            <div className="prose prose-sm max-w-none">
                <div className="text-sm text-gray-700 space-y-4">
                    <p className="font-semibold text-lg">Nexus Workspace Management System</p>

                    <div>
                        <h3 className="font-semibold text-base text-gray-900 mb-2">1. Introduction</h3>
                        <p className="text-gray-600 mb-3">
                            Welcome to Nexus Workspace Management System ("Nexus," "we," "our," or "us").
                            This Privacy Policy explains how we collect, use, disclose, and safeguard your
                            information when you use our workspace management platform and related services.
                        </p>
                        <p className="text-gray-600">
                            Nexus is a comprehensive workspace management system that facilitates the management
                            of coworking spaces, office bookings, contracts, customer relationships, and related business operations.
                        </p>
                    </div>

                    <div>
                        <h3 className="font-semibold text-base text-gray-900 mb-2">2. Information We Collect</h3>
                        <div className="ml-4 space-y-2">
                            <div>
                                <h4 className="font-medium text-gray-800">2.1 Personal Information</h4>
                                <p className="text-gray-600 text-xs">
                                    We collect personal information that you provide directly to us, including:
                                    Contact Information (name, email, phone), Identity Information (CNIC),
                                    Account Information (username, password, role assignments), Professional Information,
                                    and Location Information.
                                </p>
                            </div>
                            <div>
                                <h4 className="font-medium text-gray-800">2.2 Workspace Usage Information</h4>
                                <p className="text-gray-600 text-xs">
                                    We collect information related to your workspace usage: Booking Information,
                                    Contract Details, Access Information, and Space Preferences.
                                </p>
                            </div>
                            <div>
                                <h4 className="font-medium text-gray-800">2.3 Technical Information</h4>
                                <p className="text-gray-600 text-xs">
                                    We automatically collect certain technical information: Device Information,
                                    Usage Analytics, Cookies and Tracking, and Log Data.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div>
                        <h3 className="font-semibold text-base text-gray-900 mb-2">3. How We Use Your Information</h3>
                        <div className="ml-4 space-y-2">
                            <div>
                                <h4 className="font-medium text-gray-800">3.1 Core Services</h4>
                                <p className="text-gray-600 text-xs">
                                    We use your information to provide our workspace management services:
                                    Account Management, Space Bookings, Contract Management, Customer Support,
                                    and Billing and Payments.
                                </p>
                            </div>
                            <div>
                                <h4 className="font-medium text-gray-800">3.2 Business Operations</h4>
                                <p className="text-gray-600 text-xs">
                                    We use your information for internal business purposes: Service Improvement,
                                    Security, Compliance, and Communication.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div>
                        <h3 className="font-semibold text-base text-gray-900 mb-2">4. Data Security</h3>
                        <p className="text-gray-600 text-xs">
                            We implement appropriate technical and organizational security measures including
                            encryption, access controls, regular audits, and employee training to protect your data.
                        </p>
                    </div>

                    <div>
                        <h3 className="font-semibold text-base text-gray-900 mb-2">5. Your Rights</h3>
                        <p className="text-gray-600 text-xs">
                            You have the right to access, correct, delete, and port your personal information.
                            You can also control communication preferences and withdraw consent for data processing.
                        </p>
                    </div>

                    <div>
                        <h3 className="font-semibold text-base text-gray-900 mb-2">6. Contact Information</h3>
                        <p className="text-gray-600 text-xs">
                            If you have questions about this Privacy Policy or our data practices, please contact us
                            at <a href="mailto:info@firerio.com" className="text-orange-500">info@firerio.com</a> or through our support channels.
                        </p>
                    </div>

                    <div className="text-center pt-4">
                        <p className="text-xs text-gray-500">
                            This is a summary of our Privacy Policy. For the complete policy, please visit our website.
                        </p>
                    </div>
                </div>
            </div>
        </ModalX>
    );
};

export default PrivacyPolicyModal;
